import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '漫画韩漫网址是什么网站？',
    a: '漫画韩漫网址是一个专门整理和分类韩漫（韩国漫画）的内容导航站。我们按恋爱、都市、奇幻、校园、悬疑、热血等题材把海量韩漫整理归类，让你能快速定位到想看的漫画。',
  },
  {
    q: '如何在网站上快速找到某一题材的韩漫？',
    a: '你可以通过顶部导航进入"题材分类"，选择恋爱、都市、奇幻、校园、悬疑或热血中的任意分类，即可查看该题材下整理好的韩漫列表。也可以直接在搜索框输入书名或关键词快速检索。',
  },
  {
    q: '网站收录的韩漫会经常更新吗？',
    a: '会的。我们持续跟踪最新连载动态，首页"本周更新"板块会展示近期有新内容的韩漫，帮助喜欢追更的读者不错过每一话。',
  },
  {
    q: '恋爱和都市题材的区别是什么？',
    a: '恋爱题材侧重浪漫情感、心动与虐恋情节；都市题材则更聚焦现代都市背景下的职场、生活与人生选择。两者在氛围和叙事重心上有所不同，你可以按喜好选择。',
  },
  {
    q: '我可以收藏喜欢的韩漫吗？',
    a: '目前网站提供清晰的分题材浏览与编辑推荐。后续我们会陆续加入收藏与追更功能，让管理你的韩漫追番清单更加方便。',
  },
  {
    q: '如何联系网站或反馈推荐？',
    a: '欢迎通过"联系我们"页面提交你的韩漫推荐或使用反馈，我们的编辑团队会认真查看每一条建议，让分类和推荐越来越准确。',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <p className="text-xs font-medium tracking-widest text-accent-600 mb-2">常见问题</p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">关于本站，你想知道的都在这里</h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              针对韩漫题材分类、使用方式和内容更新的常见疑问，我们都帮你解答。如果还有不清楚的地方，欢迎随时联系我们。
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              联系编辑团队 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((item, i) => (
                <div
                  key={item.q}
                  className="bg-background-100/70 border border-background-200 rounded-2xl overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(open === i ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left hover:bg-background-100 transition-colors"
                    aria-expanded={open === i}
                  >
                    <h3 className="font-medium text-foreground-950 text-sm md:text-base">{item.q}</h3>
                    <span
                      className={`w-8 h-8 shrink-0 rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 transition-transform ${open === i ? 'rotate-45' : ''}`}
                    >
                      <i className="ri-add-line" aria-hidden="true"></i>
                    </span>
                  </button>
                  {open === i && (
                    <div className="px-5 md:px-6 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">{item.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}